import { useState } from "react";
import { Play, X, Youtube } from "lucide-react";

export default function MusicCard({ track, channelUrl, index }) {
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);
  const id = track.youtube_id?.trim();

  const thumb = id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;

  return (
    <>
      <div
        data-testid={`music-card-${index}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="group relative rounded-2xl overflow-hidden bg-[#fbf6ec] border border-[#e3b4b0]/50 shadow-[0_8px_30px_rgba(156,85,96,0.08)] transition-all duration-500 hover:shadow-[0_16px_50px_rgba(156,85,96,0.20)] hover:-translate-y-1"
      >
        <div className="relative aspect-square overflow-hidden">
          {id && hover ? (
            <iframe
              title={track.title}
              className="absolute inset-0 w-full h-full scale-125"
              src={`https://www.youtube.com/embed/${id}?autoplay=1&controls=0&loop=1&playlist=${id}&modestbranding=1&playsinline=1`}
              allow="autoplay; encrypted-media"
              frameBorder="0"
            />
          ) : thumb ? (
            <img src={thumb} alt={track.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-[#e3b4b0] via-[#d79aa0] to-[#9c5560] flex items-center justify-center">
              <div className="w-24 h-24 rounded-full border border-[#f7efe2]/50 flex items-center justify-center animate-float">
                <span className="font-display text-3xl text-[#f7efe2]">432</span>
              </div>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[#281620]/55 via-transparent to-transparent" />

          {id && (
            <button
              data-testid={`music-play-${index}`}
              onClick={() => setOpen(true)}
              className="absolute inset-0 flex items-center justify-center"
              aria-label={`Play ${track.title}`}
            >
              <span className="w-16 h-16 rounded-full bg-[#f7efe2]/85 backdrop-blur-sm flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
                <Play size={26} className="text-[#9c5560] ml-1" fill="#9c5560" />
              </span>
            </button>
          )}

          {!hover && (
            <span className="absolute top-3 left-3 font-accent text-[11px] tracking-widest-2 uppercase px-3 py-1 rounded-full bg-[#f7efe2]/85 text-[#9c5560]">
              Sneak peek
            </span>
          )}
        </div>

        <div className="p-5">
          <p className="font-accent text-[11px] tracking-widest-2 uppercase text-[#c2a04b] mb-1">{track.frequency}</p>
          <h3 className="font-display text-2xl text-[#3a2630] leading-tight">{track.title}</h3>
          <p className="text-sm text-[#3a2630]/70 mt-2 leading-relaxed">{track.description}</p>
          <a
            href={id ? `https://www.youtube.com/watch?v=${id}` : channelUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`music-youtube-${index}`}
            className="inline-flex items-center gap-2 mt-4 font-accent text-sm text-[#b76e79] hover:text-[#9c5560] transition-colors"
          >
            <Youtube size={17} /> Listen on YouTube
          </a>
        </div>
      </div>

      {open && id && (
        <div
          data-testid={`music-modal-${index}`}
          className="fixed inset-0 z-[60] bg-[#281620]/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
        >
          <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <button
              data-testid={`music-modal-close-${index}`}
              onClick={() => setOpen(false)}
              className="absolute -top-12 right-0 text-[#f7efe2] hover:text-[#e3b4b0]"
            >
              <X size={30} />
            </button>
            <div className="aspect-video rounded-xl overflow-hidden shadow-2xl">
              <iframe
                title={`${track.title} player`}
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
